import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { Rest } from 'app/rest/rest_client';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { ConfirmationService } from 'primeng/api';
import { InsuranceComponentService } from 'app/modules/vehicle-inventory/services/table-management/insuranceComponent.service';
import { TranslateService } from '@ngx-translate/core';
import { InsuranceQuarterlyCalculationComponent } from '../insurance-quarterly-calculation/insurance-quarterly-calculation.component';
import { InsuranceCompFormComponent } from '../insurance-comp-form/insurance-comp-form.component';

@Component({
    selector: 'app-insurance-component-list',
    templateUrl: './insurance-component-list.component.html',
    styleUrls: ['./insurance-component-list.component.css'],
    providers: [ConfirmationService, UserTimePipe, InsuranceComponentService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InsuranceComponentListComponent extends EntityListComponent<Rest.InsuranceComponent>
implements OnInit {

  title: string = this.translate.instant('i18nMigrated.insuranceList');


  user: Rest.User;

  vehicleId: any = null;

  @Input() insurance: Rest.Insurance;
  canSeeCosts: boolean = false;

  colspan: number;
  isDeleteGranted: boolean = false;
  isCalculationGranted: boolean = false;
  isUpdateGranted: boolean = false;

  @ViewChild(InsuranceQuarterlyCalculationComponent)
	insuranceQuarterlyCalculation: InsuranceQuarterlyCalculationComponent;
  @ViewChild(InsuranceCompFormComponent, { static: true }) 
	editForm: InsuranceCompFormComponent;

  constructor(
    private insuranceComponentService: InsuranceComponentService,
    protected confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
    protected i18n: I18nService,
    authenticationService: AuthenticationService,
    protected loadingService: LoadingService,
    protected userTime: UserTimePipe,
	 protected route: ActivatedRoute,
   protected translate: TranslateService
  ) {
    super(
      insuranceComponentService,
      confirmationService,
      notificationsService,
      i18n,
      authenticationService,
      loadingService,
      userTime,
    );

    this.insuranceComponentService = insuranceComponentService;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.hasEntityFilters = true;
    this.loadFilters = false;
    this.form = this.editForm;
	  console.log("vehicleId: " + this.vehicleId);

    const user = this.authenticationService.user;
    const rolesForForm = ['INV_INSURANCE_CREATE', 'INV_INSURANCE_UPDATE'];

    this.canSeeCosts = this.authenticationService.isRoleGranted('INV_INSURANCE_COSTS_READ', user);
    this.isDeleteGranted = this.authenticationService.isRoleGranted('INV_INSURANCE_COMPONENT_DELETE', user);
    this.isCalculationGranted = this.authenticationService.isRoleGranted('INV_INSURANCE_COMPONENT_CALCULATE', user);
    this.isUpdateGranted = this.authenticationService.isRoleGranted('INV_INSURANCE_COMPONENT_UPDATE', user);
    this.colspan = 3;
    if(this.canSeeCosts) this.colspan += 2;
    if(this.isDeleteGranted) this.colspan += 1;


  }

  protected beforeLoad(): void {
    this.paginationRequest.sortAsc = false;
    if(!this.paginationRequest.sortBy){
      this.paginationRequest.sortBy = 'startDate';
    }

    if(this.insurance){
      this.paginationRequest.filters['insuranceId'] = [this.insurance.id.toString()];
    }

  }
  afterLoad() {
  }

  public onDeleteInsuranceComponent(insuranceComponent: Rest.InsuranceComponent) {

		if (this.isDeleteGranted === false) {
			return;
		}

		this.confirmationService.confirm({
			accept: () => {
				this.deleteInsuranceComponent(insuranceComponent);
			},
			key: 'insurance-component-list'
		});
	}

	deleteInsuranceComponent(insuranceComponent: Rest.InsuranceComponent) {
		var that = this;
		this.insuranceComponentService.deleteInsuranceComponent(insuranceComponent.id).then((response) => {
			if (response) {
				that.notificationsService.add(Severity.success, '', this.translate.instant('general.deleteSuccessfull'));
				that.refresh();
			} else {
				that.notificationsService.add(Severity.error, '', this.translate.instant('general.deleteError'));
			}
		});
	}

  //QUARTERLY CALCULATION
	showQuarterlyCalculation() {
		this.insuranceQuarterlyCalculation.showDialog();
	}

  editDialog(event) {

		if (!this.isUpdateGranted) {
			return;
		}

		if (!this.isSelectableColumn) {
			this.onRowDblClick({ data: event });
		}

		this.isSelectableColumn = false;
		this.isColumn = true;
	}


}
